// extracted by mini-css-extract-plugin
module.exports = {"CustomerListItemContainer":"style_CustomerListItemContainer__1G0-V","namePhoneContainer":"style_namePhoneContainer__1c3oj"};